import {
  Typography,
  ListItem,
  ListItemText,
  AvatarCurrency,
  ListItemAvatar,
  MoneyRate,
  Skeleton,
  AvatarBadge,
} from '@razz-team/ui-web';
import { MoneyType } from '@razz-team/utils';
import { useTranslation } from 'react-i18next';

export function CurrencyRateListItem({
  currency,
  rate,
}: {
  currency: string | undefined;
  rate: MoneyType | undefined;
}) {
  const { t } = useTranslation();

  return (
    <ListItem>
      <ListItemAvatar>
        {rate && currency ? (
          <AvatarBadge type="currency" currency={rate.currency}>
            <AvatarCurrency currency={currency} size={40} />
          </AvatarBadge>
        ) : (
          <Skeleton variant="circular" width={40} height={40} />
        )}
      </ListItemAvatar>
      <ListItemText
        primary={
          rate && currency ? (
            <MoneyRate currency={currency} rate={rate} />
          ) : (
            <Skeleton variant="text" />
          )
        }
        secondary={
          <Typography variant="caption" color="text.secondary">
            {t('Mid-market exchange rate')}
          </Typography>
        }
        disableTypography
      />
    </ListItem>
  );
}
